// Services accordion
const accordion = require(MODULES_PATH + '/accordion');

new accordion({
    selector: '.accordion',
    duration: 200,
    openOnInit: [],
});

new accordion({
    selector: '.case-study-accordion',
    duration: 400,
    openOnInit: [],
    collapse: true,
});

new accordion({
    selector: '.accordion-focus',
    duration: 400,
    openOnInit: [0],
    collapse: false,
});

document.addEventListener('DOMContentLoaded', function () {
    const params = new URLSearchParams(window.location.search);
    const sector = params.get('sector');

    if (!sector) return;

    const section = document.getElementById(sector);
    if (!section) return;

    const trigger = section.querySelector('.accordion-trigger');
    if (!trigger) return;

    trigger.click();
});

const allImagesWrapper = document.querySelector('.location-image-wrapper');
if (allImagesWrapper) {
    const allImages = allImagesWrapper.querySelectorAll('.location-image');

    new accordion({
        selector: '.location-accordion',
        duration: 400,
        openOnInit: [0],
        collapse: false,
        beforeOpen: (currentElement) => {
            if (allImages.length > 1) {
                const accordionItems = document.querySelectorAll('.location-accordion .accordion-item');
                const currentIndex = Array.from(accordionItems).indexOf(currentElement);

                allImages.forEach((img) => img.classList.remove('active'));

                const targetImage = allImagesWrapper.querySelector(`.location-image[data-index="${currentIndex}"]`);
                if (targetImage) {
                    targetImage.classList.add('active');
                }
            }
        },
    });
}
